// import React, { Fragment, FunctionComponent } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faHotTub } from "@fortawesome/free-solid-svg-icons";
// import { Graphics, Description } from "../styles/agency-income-metrics-styles";

// const HotTub: FunctionComponent<unknown> = () => (
//   <Fragment>
//     <Graphics>
//       <FontAwesomeIcon icon={faHotTub} />
//     </Graphics>
//     <Description>
//       This could buy you: <br /> <span>a hot tub</span>!
//     </Description>
//   </Fragment>
// );

// export default HotTub;
